// "¿La cámara muestra lluvia?" — EXPERIMENTAL. Mide nitidez (varianza del Laplaciano), contraste y brillo de
// una foto achicada en un canvas y la compara con fotos de la misma hora de días anteriores (R.lluviaEnFoto).
// Gratis y local: no usa IA paga ni le pide fotos a la cámara. Solo funciona si la imagen se puede leer en un
// canvas (en local pasa por el proxy /s3img; en producción S3 no tiene CORS y devuelve null).
import R from './reglasClima';

const cargar = (url) => new Promise((ok, mal) => {
  const im = new Image();
  im.crossOrigin = 'anonymous';
  im.onload = () => ok(im);
  im.onerror = () => mal(new Error('no carga'));
  im.src = url;
});

export async function medirFoto(url) {
  try {
    const im = await cargar(url);
    const W = 320, H = Math.max(1, Math.round((im.naturalHeight / im.naturalWidth) * W));
    const c = document.createElement('canvas');
    c.width = W; c.height = H;
    const ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(im, 0, 0, W, H);
    // se mira la mitad de arriba (cielo y fondo): ahí la lluvia y la lente mojada se notan más
    const { data } = ctx.getImageData(0, 0, W, Math.round(H * 0.6));
    const h = Math.round(H * 0.6);
    const g = new Float32Array(W * h);
    let suma = 0, suma2 = 0;
    for (let i = 0; i < W * h; i++) { const v = 0.299 * data[i * 4] + 0.587 * data[i * 4 + 1] + 0.114 * data[i * 4 + 2]; g[i] = v; suma += v; suma2 += v * v; }
    const n = W * h, brillo = suma / n, contraste = Math.sqrt(Math.max(0, suma2 / n - brillo * brillo));
    let l = 0, l2 = 0, m = 0;
    for (let y = 1; y < h - 1; y++) for (let x = 1; x < W - 1; x++) {
      const i = y * W + x;
      const lap = g[i - W] + g[i + W] + g[i - 1] + g[i + 1] - 4 * g[i];
      l += lap; l2 += lap * lap; m += 1;
    }
    const nitidez = l2 / m - (l / m) ** 2;
    return { nitidez, contraste, brillo };
  } catch (e) {
    return null; // canvas bloqueado por CORS o imagen que no carga
  }
}

/** Compara la foto actual contra las de referencia. Devuelve el resultado de R.lluviaEnFoto o null. */
export async function senalCamara(urlActual, urlsReferencia) {
  const actual = await medirFoto(urlActual);
  if (!actual) return null;
  const refs = (await Promise.all(urlsReferencia.map(medirFoto))).filter(Boolean);
  return { ...R.lluviaEnFoto(actual, refs), actual, referencias: refs.length };
}
